import { useQuery } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import type { User, PlayerProfile, ClubProfile } from "@shared/schema";
import { getQueryFn } from "@/lib/queryClient";
import { generateAndSaveRefreshToken, hasRefreshToken } from "@/lib/sessionPersistence";

interface AuthUser extends User {
  profile?: PlayerProfile | ClubProfile | null;
  isNewUser?: boolean;
}

export function useAuth() {
  const { data: user, isLoading, refetch } = useQuery<AuthUser | null>({
    queryKey: ["/api/auth/user"],
    queryFn: getQueryFn({ on401: "returnNull" }),
    retry: false,
  });
  
  const hasGeneratedToken = useRef(false);
  
  useEffect(() => {
    if (user && !hasGeneratedToken.current && !hasRefreshToken()) {
      hasGeneratedToken.current = true;
      generateAndSaveRefreshToken();
    }
  }, [user]);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    needsOnboarding: user && !user.onboardingCompleted && !user.profile,
    refetchUser: refetch,
  };
}
